<template>
  <section class="clock">
    <div class="clock__container container_wide">
      <div class="clock__timer-wrapper">
        <div class="clock__timer-title-wrapper">
          <div class="clock__timer-icon">⏱</div>
          <h2 class="clock__timer-title">
            <span class="accent">ТОРОПИТЕСЬ!</span> <br class="--no-mobile">
            Акция закончится через:
          </h2>
        </div>
        <div class="clock__timer">

          <div class="clock__timer-cell" v-for="stat in date_parts" :key="stat.name">
            <template v-if="String(stat.value).length < 2">
              <div class="clock__timer-cell-number" >
                0
                <div class="clock__timer-cell-divider"></div>
              </div>
              <div class="clock__timer-cell-number" >
                {{ stat.value }}
                <div class="clock__timer-cell-divider"></div>
              </div>
            </template>

            <template v-else>
              <div class="clock__timer-cell-number">
                {{ String(stat.value)[0] }}
                <div class="clock__timer-cell-divider"></div>
              </div>
              <div class="clock__timer-cell-number">
                {{ String(stat.value)[1] }}
                <div class="clock__timer-cell-divider"></div>
              </div>
            </template>
            
            <span>{{ stat.name }}</span>
          </div>

        </div>
      </div>

      <button
        class="button button_blue clock__button"
        @click="openPopup({ type: 'sale', form: 'clock' })"
      >
        Зафиксировать условия
      </button>

    </div>
  </section>
</template>

<script>
import CF from '../common/common-functions.js';
import constants, { endDate } from "../common/constants";

export default {
  name: 'block-clock',
	created() {
    // const pattern = /(\d{1,2}).(\d{1,2}).(\d{4})/;

    // const [_, d, m, y] = pattern.exec(constants.period.end);
    // const endDateInit = `${y}-${m}-${d}`;
    // let time_left = ((new Date(endDateInit)).getTime() - Date.now()) / 1000;
    let time_left = (endDate.getTime() - Date.now()) / 1000;
    let small_part_multiplier = 1;
    for (let i = this.date_parts.length - 1; i >= 0; --i) {
      let part = this.date_parts[i];
      part.value = Math.floor((time_left / small_part_multiplier) % (part.period || 10000));
      part.name = this.getName(part);
      small_part_multiplier = small_part_multiplier * part.period;
    }
    setInterval(this.clockTick, 1000);
  },
	data: () => ({
		date_parts: [
      {
        name: 'Дней',
        units: 'days',
        value: 0,
        period: 0,
      },
      {
        name: 'Часов',
        units: 'hours',
        value: 0,
        period: 24,
      },
      {
        name: 'Минут',
        units: 'minutes',
        value: 0,
        period: 60,
      },
      {
        name: 'Секунд',
        units: 'seconds',
        value: 0,
        period: 60,
      }
    ],
	}),
	methods: {
		clockTick() {
      for (let i = this.date_parts.length - 1; i >= 0; --i) {
        if (this.date_parts[i].value > 0) {
          --this.date_parts[i].value;
          this.date_parts[i].name = this.getName(this.date_parts[i]);
          return;
        }
        this.date_parts[i].value = this.date_parts[i].period - 1;
        this.date_parts[i].name = this.getName(this.date_parts[i]);
      }
    },
    getName(date_part) {
      return CF.getNumericalName(date_part.value, date_part.units);
    }
	}
}
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.clock {
  width: 100%;
  background: #DDDDDD;
  font-size: 20px;

  &__container {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
  }
  &__timer {
		display: grid;
    grid-template-columns: auto auto auto auto;
    column-gap: 30px;
    margin: 0 auto;
		&-wrapper {
      display: flex;
      align-items: center;
			padding: 18px 0;
		}
    &-title-wrapper {
      display: flex;
      align-items: center;
      gap: 0.9em;
    }
    &-icon {
      font-size: 3.15em;
      font-weight: bold;
      color: $primary;
    }
		&-title {
      font-size: 1em;
      text-transform: uppercase;
      margin-right: 40px;
		}
		&-cell {
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      column-gap: 5px;
			&-number {
        font-size: 48px;
				background: #000;
				border-radius: 12px;
				padding: 12px 0;
				max-width: 45px;
				width: 45px;
				text-align: center;
        color: #fff;
        position: relative;
        z-index: 1;
			}
      &-divider {
        position: absolute;
        height: 1px;
        width: 100%;
        background: #000;
        box-shadow: 0 0 28px 10px #ffffff;
        top: 50%;
        z-index: -1;
      }
			span {
        grid-column: 1/3;
				margin-top: 4px;
			}
		}
	}
  &__form {
    &--bottom {
      display: none;
    }
  }

  &__button {
    font-size: 16px;
    margin-left: 1em;
    padding: 1em 2em;
  }
}

@media (max-width: 1540px) {
  .clock {
    font-size: 18px;

    &__timer {
      column-gap: 20px;
      &-title {
        margin-right: 25px;
      }
      &-cell {
        &-number {
          font-size: 34px;
          padding: 8px 0;
          max-width: 40px;
          width: 40px;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .clock {
    font-size: 14px;

    &__form {
      display: none;
      &--bottom {
        display: grid;
        justify-content: center;
        padding-top: 20px;
      }
      .callback-form__agree{
        color: #fff;
      }
    }
    &__container {
      grid-template-columns: 1fr;
      justify-items: center;
    }
  }
}

@media (max-width: 880px) {
  .clock {
    font-size: 16px;
    &__form {
      display: none;
      &--bottom {
        display: grid;
        justify-content: center;
        padding-top: 20px;
      }
    }
    &__container {
      grid-template-columns: 1fr;
      justify-items: center;
    }

    &__timer {
      column-gap: 20px;
      &-title {
        margin-right: 55px;
      }
      &-cell {
        &-number {
          font-size: 34px;
          padding: 8px 0;
          max-width: 40px;
          width: 40px;
        }
      }
    }
  }
}

@media (max-width: 640px) {
  .clock {
    &__timer {
      column-gap: 20px;
      &-wrapper {
        display: grid;
        grid-template-columns: 1fr;
        row-gap: 12px;
      }
      &-title {
        font-size: 18px;
        margin-right: 0;
        text-align: center;
      }
      &-cell {
        &-number {
          font-size: 24px;
          padding: 8px 0;
          max-width: 26px;
          width: 26px;
          border-radius: 6px;
        }
        span {
          font-size: 12px;
        }
        &-divider {
          box-shadow: 0 0 18px 10px #ffffff99;
        }
      }
      
    }
    
    &__button {
    margin-left: 0;
    margin-bottom: 1em;
    padding: 0.7em 1.5em;
  }
  }
}

</style>
